<template>
  <div class="cmi-person-view">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="title2">
            <h2>MEET <span>OUR TEAM</span></h2>
          </div>
        </div>
      </div>
      <div class="row clearfix-team">
        <div class="col-md-12">
          <div class="remove-ext">
            <div class="team-page">
              <div class="row">
                <transition-group
                  name="animate-resource"
                  enter-active-class="animated lightSpeedIn"
                >
                  <div
                    v-for="item in personItems"
                    v-bind:key="item.pkey"
                    class="col-md-4"
                  >
                    <div class="member">
                      <div class="team">
                        <div class="team-img">
                          <img
                            class="img-responsive"
                            v-bind:src="item.per_Thumbnail"
                            alt="Leaders profile"
                          />
                        </div>
                        <div class="member-detail">
                          <h3>
                            <a href="javascript:void(0);">{{
                              item.per_Name
                            }}</a>
                          </h3>
                          <span>{{ item.per_FavouriteVerse }}</span>
                          <p>
                            {{ item.per_FavouriteVerseText }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </transition-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: {
    baseUrl: { type: String }
  },
  data() {
    return {
      personItems: []
    };
  },
  methods: {
    getPersonData: async function() {
      let rData = null;
      let actionUrl = `${this.baseUrl}GetPersonData`;
      ({ data: rData } = await axios.get(actionUrl));
      if (rData) {
        this.personItems = rData;
      }
    }
  },
  async mounted() {
    await this.getPersonData();
  }
};
</script>
